export default __webpack_public_path__ + "static/сooper-55da1d2192ee4c9c3d327d2b7c3e2e8a.webp";